<div (click)="openDialog()" class="cursor-pointer">
  {{ toastRef.data.toastMessage }}
</div>
